import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router";

export const useRegistrationToken = () => {
	const [searchParams] = useSearchParams();
	const sessionToken = sessionStorage.getItem("registrationToken");
	const token = useMemo(() => searchParams.get("token") || sessionToken || null, [searchParams, sessionToken]);

	useEffect(() => {
		token &&
			token !== sessionStorage.getItem("registrationToken") &&
			sessionStorage.setItem("registrationToken", token);
	}, [token]);

	return token;
};
